import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import translation from '../locales/tr/translation.json';

type DotPrefix<T extends string> = T extends '' ? '' : `.${T}`;

type NestedKeyOf<ObjectType extends object> = {
  [Key in keyof ObjectType & (string | number)]: ObjectType[Key] extends object
    ? // @ts-ignore
      `${Key}${DotPrefix<NestedKeyOf<ObjectType[Key]>>}`
    : `${Key}`;
}[keyof ObjectType & (string | number)];

type TranslationKeys = NestedKeyOf<typeof translation>;

export const useLocalizedText = () => {
  const { t } = useTranslation();

  return useCallback(
    (key: TranslationKeys, params?: Record<string, any>) =>
      t(key, params ?? {}) as unknown as string,
    [t],
  );
};
